<template>
    <form @submit.prevent="submit()">
        <div class="form-control d-flex" style="min-height: 5rem">
            <textarea
                class="flex-grow-1 thread-messages-container"
                placeholder="Send a message..."
                @input="$emit('update:modelValue', messageInput)"
                @keydown.enter.prevent="submit()"
                v-model="messageInput"
                :disabled="disabled"
            >
            </textarea>

            <div style="width: 3rem; height: 100%">
                <button
                    type="submit"
                    class="icon-btn icon-btn-primary ms-auto mt-3"
                    :disabled="fetching || disabled"
                >
                    <i class="fi fi-paper-plane"></i>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'MessageField',
    props: {
        modelValue: {
            type: null,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'update:modelValue'],
    data() {
        return {
            messageInput: '',
        };
    },
    watch: {
        modelValue(newValue) {
            this.messageInput = newValue;
        },
    },
    methods: {
        submit() {
            if (this.messageInput?.trim().length)
                this.$emit('submit', this.messageInput);
        },
    },
};
</script>

<style scoped>
textarea {
    all: unset;
    overflow-x: hidden; /* hides horizontal scrollbar */
    white-space: pre-wrap; /* wraps text */
    word-wrap: break-word; /* breaks long words */
    resize: none; /* optional: prevents resizing */
    width: 100%;
    overflow-y: auto;
    line-height: 1.5;
    font-size: var(--size-4);
}

.thread-messages-container {
    max-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    flex-grow: 1;
    overflow-y: auto;
    padding-right: 0.5rem;
}

.thread-messages-container::-webkit-scrollbar {
    width: 3px;
    opacity: 0;
    transition: all 0.3s ease;
}

.thread-messages-container:hover::-webkit-scrollbar {
    opacity: 1;
}

.thread-messages-container::-webkit-scrollbar-track {
    background: var(--neutral-450);
    border-radius: var(--radius-sm);
}

.thread-messages-container::-webkit-scrollbar-thumb {
    background: var(--neutral-600);
    border-radius: var(--radius-sm);
}

.thread-messages-container::-webkit-scrollbar-thumb:hover {
    background: var(--neutral-700);
}
</style>
